import { render, staticRenderFns } from "./MotivoConsulta.vue?vue&type=template&id=7d367594"
import script from "./MotivoConsulta.vue?vue&type=script&lang=js"
export * from "./MotivoConsulta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports